import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';
import { Container, i18n } from '../../../../symphony';

import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { SlDiscussContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';

import s from './AskQuestion.scss';

interface IAskQuestionProps {
	parentComponent?: 'QuestionsPaginationContainer';
}

export function AskQuestion({ parentComponent }: IAskQuestionProps) {
	useStyles(s);
	const { replies$: replies } = useContainerData(
		SlDiscussContext,
		SlDataService,
		['replies$'],
	);

	if (
		parentComponent === 'QuestionsPaginationContainer'
		&& !replies?.length
	) {
		return null;
	}

	const onClick = () => {
		const { actions$ } = Container.take(SlDiscussContext, SlActions);

		actions$.next({
			type: ActionType.OnAskAQuestionClick,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<div className="discuss-ask-question" sl-test-data="cmpAskQuestion">
			<Button
				type="button"
				className="discuss-ask-question__button"
				size="m"
				onClick={onClick}
			>
				{i18n.t('web-discuss.ask-question-button')}
			</Button>
			<Button
				type="button"
				className="discuss-ask-question__button-small"
				size="s"
				onClick={onClick}
			>
				{i18n.t('web-discuss.ask-question-button')}
			</Button>
		</div>
	);
}
